import { render, staticRenderFns } from "./inbox_detail.vue?vue&type=template&id=51371bbd&"
import script from "./inbox_detail.vue?vue&type=script&lang=js&"
export * from "./inbox_detail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports